import i18n from "@/lib/i18n/i18n";

export interface SimulationZoneRates {
    id: number;
    simulation_zone: number;
    initial_rate: number;
    current_rate: number;
}

export enum SimulationType {
    DECADAL_50 = "decadal_50",
    DECADAL_90 = "decadal_90",
    DROUGHT = "drought",
    WET = "wet",
    YEAR_2014 = "year_2014",
    YEAR_2015 = "year_2015",
    YEAR_2016 = "year_2016",
    YEAR_2017 = "year_2017",
    YEAR_2018 = "year_2018",
    YEAR_2019 = "year_2019",
    YEAR_2020 = "year_2020",
    YEAR_2021 = "year_2021",
    YEAR_2022 = "year_2022",
    YEAR_2023 = "year_2023",
    YEAR_2024 = "year_2024",
    YEAR_2025 = "year_2025",
    SENTINEL = "sentinel",
}

export enum SimulationLength {
    SHORT_TERM = "short_term",
    FOUR_WEEK = "four_week",
    LAST_APPLICATION = "last_application",
}

export interface NitrogenPlanSimulation {
    id: number;
    field_nitrogen_plan: number;
    product: number;
    initial_rate: number;
    current_rate: number;
    simulation_type: SimulationType;
    simulation_length: SimulationLength;
    rates: SimulationZoneRates[];
}

export function getSimulationTypeDisplayName(
    simulationType: SimulationType,
): string {
    return i18n.t(`rx:simulation_type.${simulationType}`);
}
